module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAzNSAxOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMS4yNzggMTAuMTg5bC0uNzctLjc3Mi43Ny0uNzczVjguNTdoLjA3NEw5LjM5Mi41MDNsMS4xOTUgMS4xOTFMMy43MzQgOC41N2gzMS4xNjJ2MS42ODhIMy43M2w2Ljg1NyA2Ljg3NS0xLjE5NSAxLjE5Mi04LjA0Ni04LjA2N2gtLjA2OHoiIGZpbGw9IiMwNTI3M0MiIGZpbGwtcnVsZT0ibm9uemVybyIvPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/back-arrow-dark.svg
// module id = Rv5H
// module chunks = 1